import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { OrdersService } from '../../../orders/services/orders.service';
import { MultiEligibleConfirmRequest } from '../models/multi-eligible.models';

@Injectable({ providedIn: 'root' })
export class MultiEligibleConfirmApiService {
  constructor(
    private readonly apiService: ApiService,
    private readonly ordersService: OrdersService
  ) {}

  confirm(payload: MultiEligibleConfirmRequest): Observable<any> {
    return this.apiService
      .post('order/multi-eligible-confirm', payload)
      .pipe(tap(() => this.ordersService.refreshOrders({ resetPage: true })));
  }
}
